var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnalyticsactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19090_12805)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1399 1.96689C9.09564 1.75394 8.96098 1.57051 8.77132 1.46515C8.58151 1.35907 8.3547 1.34034 8.15021 1.41425C2.97383 3.28853 -0.177571 8.73519 0.975069 14.2799C2.23884 20.3592 8.20002 24.2685 14.2793 23.0047C19.824 21.8521 23.5635 16.7911 23.2195 11.2966C23.2058 11.0796 23.0982 10.879 22.9253 10.7472C22.753 10.6152 22.5311 10.5648 22.3182 10.6091L15.0794 12.1139C14.1058 12.3163 13.0913 12.1235 12.2595 11.5786C11.4283 11.0329 10.8471 10.1793 10.6447 9.20563L9.1399 1.96689ZM11.296 0.760311C11.079 0.774014 10.8784 0.881585 10.7466 1.05453C10.6146 1.22674 10.5642 1.44865 10.6085 1.66159L12.1133 8.90034C12.2348 9.48484 12.5833 9.99688 13.0825 10.3236C13.5811 10.6512 14.1896 10.7668 14.7742 10.6453L22.0129 9.1405C22.2258 9.09624 22.4093 8.96158 22.5146 8.77192C22.6207 8.58211 22.6394 8.3553 22.5655 8.15081C20.8732 3.47361 16.261 0.449006 11.296 0.760311Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19090_12805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsactive);
export default __webpack_public_path__ + "static/media/Analyticsactive.7a4e0410c38b2f3c95d9088fd28cf28c.svg";
export { ForwardRef as ReactComponent };